import UtmHelper from "../helpers/UtmHelper.js"
let utmHelper = new UtmHelper();
let utmParams = utmHelper.getUtmParameters();

export const salesforcelead = {
    "recordTypeId": null,
    "leadSource": null,
    "uuiD__c": document.getElementById("mc_cid").value,
    "event_Name__c": null,
    "dealer_Number__c": window.DEALER_LOCATION.dealerNo,
    "clientele_Key__c": null,
    "web_Dealer_Name__c": window.DEALER_LOCATION.name,
    "firstName": null,
    "lastName": null,
    "email": null,
    "subject__c": null,
    "comments__c": null,
    "boat_serial_number__c": null,
    "current_Boat_Year__c": null,
    "current_Boat_Model__c": null,
    "current_Boat_Make__c": null,
    "current_Boat_HIN__c": null,
    "additional_Information__c": null,
    "message__c": null,
    "phone": null,
    "street": null,
    "address": null,
    "city": null,
    "state": null,
    "postalCode": null,
    "country": null,
    "boat_1_Interest__c": null,
    "boat_2_Interest__c": null,
    "receive_Marketing_Email__c": true,
    "receive_Text_Alerts__c": true,
    "preferred_Contact_Time__c": null,
    "consumer_s_Purchase_Intent__c": null,
    "mobile_Opt_In__c": true,
    "utM_Source__c": utmParams.utm_source,
    "utM_Term__c": utmParams.utm_term,
    "utM_Campaign__c": utmParams.utm_campaign,
    "utM_Medium__c": utmParams.utm_medium,
    "utM_Content__c": utmParams.utm_content,
    "honeyPot": null,
    "requestTime": 0,
    "brand": window.BRAND
};

export const salesforcecase = {
    "recordTypeId": null,
    "subject": null,
    "uuiD__c": null,
    "first_Name__c": null,
    "last_Name__c": null,
    "suppliedEmail": null,
    "suppliedPhone": null,
    "postal_Code__c": null,
    "country__c": null,
    "hiN__c": null,
    "description": null,
    "email_Opt_In__c": null,
    "microsite_Model_Year_Submitted__c": null,
    "microsite_Model_Submitted__c": null,
    "part_Number_1__c": null,
    "part_1_Description__c": null,
    "address_1__c": null,
    "city__c": null,
    "state__c": null,
    "preferred_Method_of_Contact__c": null,
    "Appointment_Date__c": null,
    "Appointment_Time__c": null,
    "Parts_or_Service__c": null,
    "comments__c": null,
    "honeyPot": null,
    "requestTime": 0,
    "brand": window.BRAND,
    "Dealer_Code__c": window.DEALER_LOCATION.dealerNo,
}